export const reason = [
    { label: ''},
    { label: 'Meeting' },
    { label: 'Submit Samples' },
    { label: 'Audit' },
    { label: 'TNB related' },
    { label: 'Maintenance' },
    { label: 'Repair Machines' },
];
